(function() {
'use strict';

angular.module('TR')
    .service('countryService', countryService);

function countryService(hotelSearch, $filter, $http, destinationService, imageService, $q, arrayUtil, broker, fieldGroupService, objectTypeService) {
    const service = {
        getTopDeals
    };

    const fieldTypes = fieldGroupService.getFieldTypes();
    const fieldFlags = fieldGroupService.getFieldGroup([
        fieldTypes.Global,
        fieldTypes.Titles,
        fieldTypes.IndicativePrice,
        fieldTypes.ReviewSnippets,
        fieldTypes.Url,
        fieldTypes.Summary,
        fieldTypes.Recommendations
    ]);

    //yes this looks a lot like what the hotelSearch service does, but in this case we need to run n searches
    //concurrently which the hotelSearch service is specifically designed to prevent.
    function _getHotelsForDestination(dest) {
        const domain = TRPCONFIG.Domain;
        dest.loading = true;
        const objectTypeAndId = objectTypeService.getObjectTypeAndId(dest);
        return $http.post('/api/hotels/static/gethotelsbydestination', {
            DestinationType: objectTypeAndId.Type,
            DestinationId: objectTypeAndId.Id,
            CultureCode: domain.CultureCode,
            DomainId: domain.DomainId,
            CurrencyCode: domain.CurrencyCode,
            Paging: {
                Index: 0,
                Size: 2
            },
            SortCriterion: 1,
            FilterCriteria: hotelSearch.getFilter(),
            FieldFlags: fieldFlags
        }).then(function(result) {
            return arrayUtil.map(result.data.Hotels, function(hotel) {
                const dim = TRPCONFIG.DeviceSettings.HotelAvailabilityImageSize;
                hotel.ImageUrl = imageService.getMainImageUrl(hotel.Id, dim, dim);
                hotel.MinCostStr = $filter('roundedCurrency')(hotel.MinCost);
                hotel.OriginalCostStr = $filter('roundedCurrency')(hotel.OriginalCost);
                hotel.TeaserStr = $filter('roundedCurrency')(hotel.IndicativeMinPrice);
                return hotel;
            });
        });
    }

    function getTopDeals(topn, destination, children) {
        function getHotels(children) {
            return hotelSearch.updateFilterFromFid().then(function() {
                return $q.all(arrayUtil.map(children, _getHotelsForDestination)).then(function(results) {
                    let all = [];
                    results.forEach(function(hotels, i) {
                        children[i].hotels = hotels;
                        all = all.concat(hotels);
                    });
                    broker.publish('hotelsReturnedFromSearch', all);    //make sure we publish the results so that
                    return children;                                    //urgency messaging works efficiently
                });
            });
        }

        if (children == null) {
            return destinationService.getTopChildren(topn, destination).then(getHotels);
        }
        return getHotels(children);
    }

    return service;
}
})();
